// src/pages/Blog.js
import React from 'react';
import { blogPosts } from '../data/blogData';
import BlogCard from '../components/BlogCard';
import SEO from '../components/SEO';

const Blog = () => {
  const sortedPosts = [...blogPosts].sort((a, b) => 
    new Date(b.date) - new Date(a.date)
  );

  return (
    <>
      <SEO 
        title="Franklin's Blog | Development & Design Insights"
        description="Explore articles on web development, UI/UX trends, and design philosophy"
      />
    <main className="blog-page">
      <section className="blog-archive">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="intro">
                <h1 className="title">Insights</h1>
                <p className="lead">Thoughts on design, development and innovation</p>
              </div>
            </div>
          </div>
          
          <div className="row items">
            {sortedPosts.map((post) => (
              <div className="col-md-6 col-lg-4 mb-4" key={post.id}>
                <BlogCard 
                  image={post.image}
                  title={post.title}
                  date={post.date}
                  tags={post.tags}
                  slug={post.slug}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default Blog;